import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IAccordionItem } from '@interfaces/accordion.interface';

@Component({
  selector: 'aig-accordion',
  imports: [ NgFor, NgIf, NgClass ],
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.scss'
})
export class AccordionComponent {
  @Input() items: IAccordionItem[] = [];
  @Input() prefix: string = '';
  public activeItem: number | undefined;

  constructor() {}

  ngOnInit() {}
  public changeActiveItem(index: number): void {
    if (this.activeItem === index) {
      this.activeItem = undefined;
    } else {
      this.activeItem = index;
    }
  }
}
